




































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class NavigationTabs extends Vue {
  private isActiveTab(tab: string): boolean {
    return this.$route.name == tab;
  }
}
